/* FGD-Dateien einer Karte aus der Asset-Liste des Backends wählen (ohne DOM, node-testbar). Liegen unter fgd/<name>. */
import { FGD_DIR } from '../model/modprofile.ts';

export interface FgdAsset { path: string; sha256?: string }

const base = (p: string): string => p.replace(/^.*\//, '').toLowerCase();

export const fgdAssetPath = (name: string): string => FGD_DIR + base(name);

export interface MapFgdPlan {
  /** Asset-Pfade, die noch zu laden sind */
  load: { name: string; path: string }[];
  /** schon im Editor */
  have: string[];
  /** auf dem Server nicht vorhanden */
  missing: string[];
}

/** names: Dateinamen aus xf_fgd; loaded: Namen, die der Editor schon hat */
export function planMapFgds(names: string[], assets: FgdAsset[], loaded: string[]): MapFgdPlan {
  const have = new Set(loaded.map((n) => n.toLowerCase()));
  const plan: MapFgdPlan = { load: [], have: [], missing: [] };
  for (const n of names) {
    if (have.has(n.toLowerCase())) { plan.have.push(n); continue; }
    const it = assets.find((a) => base(a.path) === n.toLowerCase());
    if (it) plan.load.push({ name: n, path: it.path }); else plan.missing.push(n);
  }
  return plan;
}

export type FgdSync =
  | { kind: 'skip' }                                   // keine FGD-Datei
  | { kind: 'upload'; path: string }                   // Name fehlt auf dem Server
  | { kind: 'same'; path: string }                     // gleicher Inhalt
  | { kind: 'differs'; path: string; owner?: string }; // gleicher Name, anderer Inhalt

/** Was mit einer lokal geladenen FGD auf dem Server geschehen soll; hash = SHA-256 der Datei (leer = unbekannt) */
export function planFgdSync(fileName: string, hash: string, assets: (FgdAsset & { owner?: string })[]): FgdSync {
  const name = base(fileName.replace(/\\/g, '/'));
  if (!/\.fgd$/.test(name)) return { kind: 'skip' };
  const it = assets.find((a) => base(a.path) === name);
  if (!it) return { kind: 'upload', path: fgdAssetPath(name) };
  if (hash && it.sha256 && hash !== it.sha256) return { kind: 'differs', path: it.path, owner: it.owner };
  return { kind: 'same', path: it.path };
}
